<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Details">
      <div class="edit-partner-embed-dialog-form">
        <mat-form-field>
          <mat-label>Partner Embed Name (Not Visible To Partner)</mat-label>
          <input matInput name="targetEmbed.name" [(ngModel)]="targetEmbed.name" />
        </mat-form-field>
        <ng-container>
          <mat-label>Notes</mat-label>
          <textarea name="targetEmbed.notes" [(ngModel)]="targetEmbed.notes"></textarea>
        </ng-container><br />
        <mat-form-field>
          <mat-label>Interactive</mat-label>
          <mat-select
            name="targetEmbed.interactId"
            [(ngModel)]="targetEmbed.interactId"
            (selectionChange)="updateInteractiveData()"
          >
            <mat-option *ngFor="let interact of allInteracts" [value]="interact.interactId">
              {{interact.interactName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Start Page</mat-label>
          <mat-select
            name="targetEmbed.startPageName"
            [(ngModel)]="targetEmbed.startPage">
            <mat-option [value]="''">Default Start Page</mat-option>
            <mat-option *ngFor="let page of interactPages" [value]="page.name">
              {{page.displayName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <ng-container>
          <mat-checkbox name="targetEmbed.enabled" [(ngModel)]="targetEmbed.enabled"
          >Enabled?</mat-checkbox
          > </ng-container
        ><br />
        <ng-container>
          <mat-checkbox name="targetEmbed.allowRemoteFiltering" [(ngModel)]="targetEmbed.allowRemoteFiltering"
          >Allow Remote Filtering?</mat-checkbox
          > </ng-container
        ><br />
      </div>
    </mat-tab>
    <mat-tab label="Page Restrictions">
      <mat-card>
        <mat-card-content>
          <div class="row input-table-row">
            <div class="col-md-1">Page: </div>
            <div class="col-md-7">
              <mat-select [(value)]="selectedPage">
                <mat-option *ngFor="let page of interactPages" [value]="page">{{ page.displayName }}</mat-option>
              </mat-select>
            </div>
            <div class="col-md-4">
              <button mat-button class="piNarrowButton" (click)="addPageRestriction()">Add Restriction</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mainLabel">Display Name</div>
            <div class="col-md-4 mainLabel">Page Name</div>
            <div class="col-md-4 mainLabel">Actions</div>
          </div>
          <ng-container *ngFor="let pageRestriction of pageRestrictions; let idx = index;">
            <div class="row table-row">
              <div class="col-md-4">{{pageRestriction.displayName}}</div>
              <div class="col-md-4">{{pageRestriction.page}}</div>
              <div class="col-md-4">
                <button mat-button class="piNarrowButton" (click)="removePageRestriction(idx)">Remove</button>
              </div>
            </div>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <!--<mat-tab label="Pre-Filters">
      <mat-card>
        <mat-card-content>
          <div class="row">
            <h5>Pre Filter Values</h5>
          </div>
          <div class="row">
            <div class="col-md-5"><button mat-button class="piButton" (click)="editPreFilterValues()">Edit Pre Filter Values</button></div>
            <div class="col-md-5"></div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-tab>-->
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onConfirmClick()">
    Save Partner Embed
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
